import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingPanel } from "../LoadingPanel";
import { addNotificationWithTimeout } from '../../app/addNotificationWithTimeout';
import { handleResponse } from '../../app/handleResponse';
import { getCSRFToken } from '../../app/getCSRFToken';
import { useDisableNumberInputScroll } from '../../app/useDisableNumberInputScroll';
import { NumericTextBox } from "@progress/kendo-react-inputs";
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";

export const AdministratorTicketingWebsitePOSCustomers = (props) => {
    const dispatch = useDispatch();

    const [ticketingWebsitePOSCustomers, setTicketingWebsitePOSCustomers] = useState([]);
    const [areTicketingWebsitePOSCustomersLoading, setAreTicketingWebsitePOSCustomersLoading] = useState(true);

    const getTicketingWebsitePOSCustomers = () => {
        setAreTicketingWebsitePOSCustomersLoading(true);

        fetch(`/api/administrator/ticketingwebsiteposcustomers`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify({}),
            })
            .then(handleResponse)
            .then(result => {
                setTicketingWebsitePOSCustomers(result);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            })
            .finally(() => {
                setAreTicketingWebsitePOSCustomersLoading(false);
            });
    }

    const saveTicketingWebsitePOSCustomer = (ticketingWebsiteId, posCustomerId) => {   
        if (!posCustomerId) {
            addNotificationWithTimeout(dispatch, "error", "The POS Customer Id must be a number.");
            return;
        }

        setAreTicketingWebsitePOSCustomersLoading(true);

        const dataItem = {
            ticketingWebsiteId: ticketingWebsiteId,
            posCustomerId: parseInt(posCustomerId),
        }

        fetch("/api/administrator/ticketingwebsiteposcustomer",
            {
                method: "PUT",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", "Updated ticketing website successfully");

                getTicketingWebsitePOSCustomers();
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setAreTicketingWebsitePOSCustomersLoading(false);
            });
    }

    const posCustomerIdChanged = (ticketingWebsiteId, event) => {
        saveTicketingWebsitePOSCustomer(ticketingWebsiteId, event.target.element.value);
    };

    const POSCustomerIdCell = (props) => {
        //Use the custom hook to disable scrolling in number inputs
        useDisableNumberInputScroll();

        const posCustomerId = props.dataItem.posCustomerId;
        const ticketingWebsiteId = props.dataItem.ticketingWebsiteId;

        return (
            <td className="text-center">
                <NumericTextBox
                    value={posCustomerId}
                    onBlur={(event) => posCustomerIdChanged(ticketingWebsiteId, event)}
                />
            </td>
        );
    };

    useEffect(() => {
        document.title = "Ticketing Website POS Customers";

        getTicketingWebsitePOSCustomers();
    }, []);

    return (
        <>
            <Grid
                data={ticketingWebsitePOSCustomers}
                dataItemKey={"ticketingWebsiteId"}
                resizable={true}
                scrollable="none"
            >
                <Column field="ticketingWebsiteName" title={"Website"} editable={false} />
                <Column title={"POS Customer Id"} cell={POSCustomerIdCell} />
            </Grid>

            {areTicketingWebsitePOSCustomersLoading ? <LoadingPanel /> : <></>}
        </>
    );
}